import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query ModalityConversions($search: String, $perPage: Int, $page: Int) {
    ModalityConversions(search: $search, perPage: $perPage, page: $page) {
      items {
        id
        colligate {
          active
          partnerVisibleName
        }
        idColligate
        databaseName
        idModality
        modalityName
        createdAt
        updatedAt
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface item {
  id: number;
  colligate: {
    active: boolean;
    partnerVisibleName: string;
  };
  databaseName: string;
  idColligate: number;
  idModality: string;
  modalityName: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface GetAllGql {
  ModalityConversions: {
    items: item[];
    paginationInfo: PaginationInfo;
  };
}
